import axios from 'axios';
import { toast } from 'react-toastify';
const API_URL = process.env.REACT_APP_BACKEND_URL + '/api/categories';

export const getCategories = async () => {
    try {
        const response = await axios.get(API_URL);
        return response.data;
    } catch (error) {
        // Don't show toast for authentication errors (expected during user switching)
        if (error.response?.status !== 401) {
            const message = (
                error.response && error.response.data && error.response.data.message) ||
                error.message || error.toString();
            toast.error(message);
        }
        return []; // Return empty array on error
    }
};

export const createCategory = async (categoryData) => {
    const response = await axios.post(API_URL, categoryData);
    return response.data;
};

export const deleteCategory = async (categoryId) => {
    const response = await axios.delete(`${API_URL}/${categoryId}`);
    return response.data;
};

export const updateCategory = async (categoryId, categoryData) => {
    const response = await axios.put(`${API_URL}/${categoryId}`, categoryData);
    return response.data;

};

export const addSubCategory = async (categoryId, subData) => {
  const { data } = await axios.post(`${API_URL}/${categoryId}/subcategories`, subData);
  return data; // newly created sub‑category
};

export const updateSubCategory = async (categoryId, subId, subData) => {
  const { data } = await axios.put(`${API_URL}/${categoryId}/subcategories/${subId}`, subData);
  return data;
};

export const deleteSubCategory = async (categoryId, subId) => {
  const { data } = await axios.delete(`${API_URL}/${categoryId}/subcategories/${subId}`);
  return data;
};
